module.exports = __webpack_public_path__ + "img/car-yellow-right.9dec9ab4.jpg";